export default from './PageViewCompareNew';